import { AxiosResponse } from "axios";
import CancelRequestError from "../services/CancelRequestError";
import HierarchyService from "../services/use_case/hierarchy/HierarchyService";
import HierarchyResponse from "../services/use_case/hierarchy/HierarchyResponse";
import ActionType from "./Action";
import * as actionTypes from './types';

let hierarchyService: HierarchyService;

/*
 * Hierarchy — initial load (page 1)
 */
export const hierarchyFetch = () => {

    return async (dispatch: any) => {

        dispatch( hierarchyCancelRequest() );

        dispatch( hierarchyChangeValue('rootUser',  null) );
        dispatch( hierarchyChangeValue('children',  null) );
        dispatch( hierarchyChangeValue('isLoading', true) );

        try {
            const response: AxiosResponse<HierarchyResponse> = await hierarchyService.fetch(1);
            dispatch( hierarchyFetchResponse(response.data) );
        } catch (error) {
            if ( !(error instanceof CancelRequestError) )
                dispatch( hierarchyChangeValue('isLoading', false) );
        }

    };

};

export const hierarchyFetchResponse = (payload: HierarchyResponse): ActionType<HierarchyResponse> => ({
    type: actionTypes.HIERARCHY_FETCH,
    payload,
});

/*
 * Hierarchy — load next page
 */
export const hierarchyFetchNext = (page: number) => {

    return async (dispatch: any) => {

        dispatch( hierarchyChangeValue('isLoadingMore', true) );

        try {
            const response: AxiosResponse<HierarchyResponse> = await hierarchyService.fetch(page);
            dispatch( hierarchyFetchNextResponse(response.data) );
        } catch {
            dispatch( hierarchyChangeValue('isLoadingMore', false) );
        }

    };

};

export const hierarchyFetchNextResponse = (payload: HierarchyResponse): ActionType<HierarchyResponse> => ({
    type: actionTypes.HIERARCHY_FETCH_NEXT,
    payload,
});

/*
 * Cancel & re-initialise service
 */
export const hierarchyCancelRequest = () => {

    return async () => {
        hierarchyService?.cancelRequest();
        hierarchyService = new HierarchyService();
    };

};

export const hierarchyChangeValue = (key: string, value: any): ActionType<any> => ({
    type: actionTypes.HIERARCHY_CHANGE_VALUE,
    payload: { key, value },
});
